import React, { useContext, useState } from "react";
import {
  extensionTamañoDeArchivoValido,
  jsonEstaVacio,
  parseExtensionesToString,
} from "../../../helper/utils";
import GenericUploadFileV2 from "../../../components/GenericUploadFile/GenericUploadFileV2";
import { AlertErrorExcelFile2MBSizeMessage } from "../../../components/alerts/AlertErrorMaxFileSizeMessage";
import { FILE_SIZE_2MB } from "../../../constants/hardCodedConstants";
import GenericModal from "../../../components/modal/GenericModal";
import { AuthContext } from "../../../hooks/context/authContext";
import { useManagePostRequest } from "../../../hooks/useManagePostRequest/useManagePostRequest";

const SubirArchivoUpdateUtilidades = ({
	api,
	tittle = "Cargar archivo",
	toggleModal,
	refreshPage,
    validExtensions
}) => {
    const { state } = useContext(AuthContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [uploadFileHelpDesk, setUploadFileHelpDesk] = useState({});
    const [executePost] = useManagePostRequest();

    const handleSubmit = async (e) => {
		e.preventDefault();
		setIsSubmitting(true);
		try {
		let payload = {
			"ArchivoDatosBancoUtilidades": uploadFileHelpDesk
		};
		await executePost(api, payload, successSubmitCallback);
		} catch (error) {
		console.error(error);
		}
		setIsSubmitting(false);
	};

    const successSubmitCallback = async () => {
		refreshPage && (await refreshPage());
		toggleModal();
	};

    return (
    <GenericModal showModal={toggleModal} width={"650px"} titulo={tittle}>
        <div className="modal-body pt-0 pl-0 pb-0">
            <form onSubmit={handleSubmit}>
                <div className="form-group row mb-4">
					<label className="col-sm-6 col-form-label modal-label">
					  Descarga plantilla
					</label>
                    <div className="col-sm-6 px-0 d-flex">
                        <a className='card-link hand-pointer' 
                            target="_blank" 
                            href="https://docs.google.com/spreadsheets/d/14LAvup9kgwkYzu9Un2q3n6452CJbVOMr/edit?usp=sharing&ouid=115561639493701433591&rtpof=true&sd=true">
                                <strong>FORMATO ACTUALIZACIÓN CUENTA Y BANCO - UTILIDADES</strong></a>
                    </div>
                </div>
                <div className="form-group row mb-4">
                    <label className="col-sm-6 col-form-label modal-label">
					  Archivo
					</label>
					<div className="col-sm-6 px-0 d-flex">
						<GenericUploadFileV2
							uploadFileToS3={setUploadFileHelpDesk}
							id={0}
							textButton={"Adjuntar archivo"}
							extensionesValidas={validExtensions}
							ToastArchivoNoValido={AlertErrorExcelFile2MBSizeMessage}
							maxFileSize={FILE_SIZE_2MB}
							showToastSuccess={false}
						  />
					</div>
                </div>
                <div className="modal-footer justify-content-end">
                    <div>
                        <button
                            type="submit"
                            className="btn generic-button-buscador"
                            disabled={isSubmitting || jsonEstaVacio(uploadFileHelpDesk)}>
                            Cargar
                        </button>
                    </div>
                </div>


            </form>
        </div>
    </GenericModal>
    );
};

export default SubirArchivoUpdateUtilidades;